// Path-addressing into a WHERE `BooleanNode` tree (Slice 3B.3). A path is the
// array of child indices from the root (`[0,1]` = root.children[0].children[1]).
// Pure; returns undefined for any index that runs off the tree or descends into
// a leaf.

import type { BooleanNode, QueryStructure } from '../types';
import type { BooleanClauseTarget, NodePath } from '../types/structuralEdit';

export function resolveNodePath(root: BooleanNode, path: NodePath): BooleanNode | undefined {
  let node: BooleanNode = root;
  for (const idx of path) {
    if (node.kind !== 'group') return undefined;
    const child = node.children[idx];
    if (!child) return undefined;
    node = child;
  }
  return node;
}

// Resolve which boolean-tree the `clause` discriminator anchors a tree edit to:
// `structure.havingTree` for clause === 'having', else `structure.whereTree`
// (the default when `clause` is absent). Returns `undefined` when the selected
// clause has no tree — every planner's `if (!root) return []` guard then yields
// a clean no-op, exactly as before for a missing WHERE.
export function clauseTreeRoot(
  structure: QueryStructure,
  clause: BooleanClauseTarget | undefined,
): BooleanNode | undefined {
  return clause === 'having' ? structure.havingTree : structure.whereTree;
}
